import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';

import Row from './Row';

class Page extends Component {

    static propTypes = {
        className: React.PropTypes.string,
        children: React.PropTypes.node
    };

    render() {
        let classes = {
            'page-main': true
        };

        let {className, children, ...props} = this.props;

        return (
            <div className={classNames(classes, className)} {...props}>
                <Row>
                    {children}
                </Row>
            </div>
        );
    }
}

export default Page;